// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff565c89","488":"df9d2e37","732":"af2d55ab","867":"5047d3a5"}[chunkId] + ".chunk.js";
};